import { ENDPOINT, RELATIONSHIP } from "../utils/constants";
import { request } from "../utils/request";

const faqFields = [
  "id",
	"title_i18n",
  `${RELATIONSHIP.FAQ_TOPICS_TO_QUESTIONS}.id`,
	`${RELATIONSHIP.FAQ_TOPICS_TO_QUESTIONS}.title_i18n`,
	`${RELATIONSHIP.FAQ_TOPICS_TO_QUESTIONS}.answer_i18n`,
	`${RELATIONSHIP.FAQ_TOPICS_TO_QUESTIONS}.position`
];

export const getFaqTopics = async language => {
	return request({
		url: `${ENDPOINT.FAQ_TOPICS}?fields=${faqFields.join(",")}&nestedFields=${RELATIONSHIP.FAQ_TOPICS_TO_QUESTIONS}&pageSize=0&sort=position:asc`,
		method: "get",
	}).then(data => {
		const currentLanguage = getLanguageAttributeKey(data.items[0].title_i18n, language);

		return data.items.map(faqTopic => {
			const sortedQuestions = sortTopicQuestions(faqTopic[RELATIONSHIP.FAQ_TOPICS_TO_QUESTIONS]);

			return {
        id: faqTopic?.id,
				title: faqTopic?.title_i18n[currentLanguage],
				questions: simplifyQuestionsStructure(sortedQuestions, currentLanguage),
			};
		});
	});
};

function simplifyQuestionsStructure(questions, currentLanguage) {
	return questions.map(current_question => ({
    id: current_question?.id,
		title: current_question?.title_i18n[currentLanguage],
		answer: current_question?.answer_i18n[currentLanguage],
	}));
}

function sortTopicQuestions(questions) {
	return questions.sort(
		(questionA, questionB) => questionA?.position - questionB?.position
	);
}

function getLanguageAttributeKey(attributeKey, language) {
	return Object.keys(attributeKey).filter(key => key.includes(language));
}

